import { useTranslation } from "react-i18next";
import { enhancedT } from "Utils";

const useI18n = localeFiles => {
  const { t: originalT, ...rest } = useTranslation(localeFiles);

  // Use enhanced `t`
  const t = enhancedT(originalT);

  return { t, ...rest };
};

export default useI18n;
